import React, { useState, useEffect } from 'react';
import CheckoutForm from '@/components/checkout/CheckoutForm';

export default function Checkout() {
  const [selectedPlan, setSelectedPlan] = useState<string>('plus');
  const [lockedCoupon, setLockedCoupon] = useState<string>('');

  useEffect(() => {
    // Set initial plan based on URL params or storage
    const urlParams = new URLSearchParams(window.location.search);

    // Cupom promocional: URL tem prioridade, com fallback pro que o Signup
    // guardou na sessão (sobrevive a um refresh da página de checkout).
    const couponParam = urlParams.get('coupon') || sessionStorage.getItem('promo_coupon') || '';
    if (couponParam) {
      setLockedCoupon(couponParam);
      sessionStorage.setItem('promo_coupon', couponParam);
    }

    const planParam = urlParams.get('plan') || sessionStorage.getItem('promo_plan');
    const planStorage = localStorage.getItem('id_plan');

    if (planParam && ['light', 'plus', 'premium'].includes(planParam)) {
      setSelectedPlan(planParam);
      sessionStorage.setItem('promo_plan', planParam);
    } else if (planStorage) {
      // Map storage plan to our plan keys
      const lightPlan = import.meta.env.VITE_PROD_LIGHT;
      const lightPlan87 = import.meta.env.VITE_PROD_LIGHT87;
      const lightPlanVslDynamic = import.meta.env.VITE_PROD_LIGHT_VSL_DYNAMIC;
      const lightPlanVslDynamic97 = import.meta.env.VITE_PROD_LIGHT_VSL_DYNAMIC97;
      const plusPlan = import.meta.env.VITE_PROD_PLUS;
      const premiumPlan = import.meta.env.VITE_PROD_PREMIUM;

      const planMap: Record<string, string> = {
        [lightPlan]: 'light',
        [lightPlan87]: 'light',
        [lightPlanVslDynamic]: 'light',
        [lightPlanVslDynamic97]: 'light',
        [plusPlan]: 'plus',
        [premiumPlan]: 'premium',
      };

      const mappedPlan = planMap[planStorage];
      if (mappedPlan) {
        setSelectedPlan(mappedPlan);
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <CheckoutForm selectedPlan={selectedPlan} setSelectedPlan={setSelectedPlan} lockedCoupon={lockedCoupon} />
    </div>
  );
}
